const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('addCertificate', ['Authorization', '$translate', function (Authorization, $translate) {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      content: '=',
      instructions: '=',
      onChange: '&?',
      type: '=?'
    },
    template: require('../../../templates/directives/cms/add-certificate.html'),
    controller: ['$scope', '$sce', function ($scope, $sce) {
      var self = this;
      self.user = Authorization.getAuthToken() && Authorization.getAuthToken().user || {};
      self.date = new Date();
      self.translations = {};
      self.type = '';

      self.showPreview = false;
      self.closePreview = function() {
        self.showPreview = false;
      };
      self.alt_title = '';
      self.hide_completion = false;

      self.initialValues = function() {
        if (!$scope.content.certificate_data || !$scope.content.certificate_data.length) {
          return;
        }

        $scope.content.certificate_data.forEach(function(item) {
          if (item.name) {
            self[item.name] = item.value === 'true' ? true : item.value === 'false' ? false : item.value;
          }
        });
      };

      self.setDataValue = function(name, value) {
        var replaced = false;
        if (!$scope.content.certificate_data) {
          $scope.content.certificate_data = [];
        }

        $scope.content.certificate_data.forEach(function(item) {
          if (item.name === name) {
            item.value = value;
            replaced = true;
            return;
          }
        });

        if (!replaced) {
          $scope.content.certificate_data.push({name: name, value: value});
        }
      };

      self.save = function(type) {
        if (type === 'alt_title') {
          self.setDataValue('alt_title', self.alt_title);
        }
        if (type === 'hide_completion') {
          self.setDataValue('hide_completion', self.hide_completion);
        }

        if ($scope.onChange) {
          $scope.onChange();
        }
      };

      self.initialValues();

      $translate([
        'addCertificate.type_assessment',
        'addCertificate.type_track',
        'addCertificate.type_workshop',
        'addCertificate.type_scorm',
        'addCertificate.type_default'
      ]).then(function(translations){
        self.translations = translations;
        self.getType = function(){
          var keys = {
            "assessment": self.translations['addCertificate.type_assessment'],
            "track": self.translations['addCertificate.type_track'],
            "workshop": self.translations['addCertificate.type_workshop'],
            "scorm": self.translations['addCertificate.type_scorm'],
            "default": self.translations['addCertificate.type_default']
          };
          if ($scope.type ) {
            self.type =  $sce.getTrustedHtml( keys[$scope.type]);
          } else {
            self.type = $sce.getTrustedHtml( keys['default']);
          }
        };
        self.getType();
      });

    }],
    controllerAs: 'addCertificate'
  }
}]);